<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersConnections",
  data() {
    return {
      series:[],
      seriesA13:[],
      chartOptions: {
        chart: {
          id: 'users-tokens',
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,

            datetimeUTC: false,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        colors: ["#666666", "#34c38f"],
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          }
        },
        noData: {
          text: 'Loading...'
        }
      },
      chartA13Options: {
        chart: {
          id: 'a13-notifications',
          type: 'bar',
          stacked: true,
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,

            datetimeUTC: false,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        colors: ["#34c38f", "#666666"],
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          }
        },
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: '1W',
        options: [
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersTokens(params)
          .then(response => {
            const data = response.data;
            this.$refs.usersTokensChart.updateSeries([
              {
                name: 'total',
                type: 'line',
                data: data.stats.total
              },
              {
                name: "With Tokens",
                data: data.stats.withTokens,
                type: 'area',
              }
            ]);

            this.$refs.a13NotificationsChart.updateSeries([
              {
                name: "Notifications ON",
                data: data.stats.notificationsEnabled,
                type: 'bar',

              },{
                name: "Notifications OFF",
                data: data.stats.notificationsDisabled,
                type: 'bar',
              }]);
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersTokens failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartConnections">
    <b-form-radio-group
        v-model="filtersDates.selected"
        :options="filtersDates.options"
        button-variant="outline-secondary"
        size="sm"
        buttons
        class="mt-1 mb-2"
        @change="handleDateChange"
    ></b-form-radio-group>
    <div class="row">
      <div class="col-12 col-lg-6">
        <h5 class="card-title">Users Tokens History</h5>
        <apexchart
            ref="usersTokensChart"
            type="line"
            dir="ltr"
            height="350"
            :series="series"
            :options="chartOptions"
        ></apexchart>
      </div>
      <div class="col-12 col-lg-6">
        <h5 class="card-title">Android 13+ Notifications Activation History</h5>
        <apexchart
            ref="a13NotificationsChart"
            type="bar"
            dir="ltr"
            height="350"
            :series="seriesA13"
            :options="chartA13Options"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<style>
#cardChartConnections .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartConnections .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>